import template from './ko-field-view-file.html';

class FileComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);
		this.files = ko.observableArray([]);
		this.files_location = ko.observable(`/DAV/FieldFiles/${params.name}`);

		if (params.ui_fields && params.ui_fields.upload_url !== '')
			this.files_location(params.ui_fields.upload_url);

		this.load_files();
	}

	load_files()
	{
		let input = this.value();
		let files = [];

		// Clear previously loaded files to avoid duplicates
		this.files.removeAll();

		if (!input) return;

		if (typeof input === 'string')
		{
			try {
				const parsed = JSON.parse(input);
				if (Array.isArray(parsed))
					files = parsed;
				else if (parsed && typeof parsed === 'object')
					files = [parsed];
				else
				{
					console.error('Invalid data after parsing JSON, expected file object or array:', parsed);
					return;
				}
			} catch (error) {
				console.error('Error parsing JSON string:', error);
				return;
			}
		}
		else if (Array.isArray(input))
			files = input;
		else if (input && typeof input === 'object')
			files = [input];
		else
		{
			console.error('Invalid value data, expected a string, array, or object:', input);
			return;
		}

		files.forEach(file => {
			if (file && typeof file.name === 'string' && typeof file.fullPath === 'string')
			{
				this.files.push({
					name: file.name,
					fullPath: file.fullPath,
				});
			}
			else
				console.error('Invalid file object:', file);
		});
	}

	async open_file(file)
	{
		try {
			if (file.fullPath)
				window.open(file.fullPath, '_blank');
			else
			{
				const fileUrl = `${this.files_location()}/${file.name}`;
				window.open(fileUrl, '_blank');
			}
		} catch (error) {
			console.error('Error opening file:', error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: 'Unable to open file.' });
		}
	}
}

export default {
	name: 'ko-field-view-file',
	viewModel: FileComponentVM,
	module_type: 'ko',
	template: template
}
